import axios from "axios";
export default function setup() {
  axios.interceptors.request.use(
    function (config) {
      const token = localStorage.token;
      if(config.url.indexOf("maps.googleapis.com") == -1){
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
     
      return config;
    },
    function (err) {

      return Promise.reject(err);
    }
  );
}
